import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';
import { DbservicesProvider } from '../../providers/dbservices/dbservices';
@IonicPage()
@Component({
  selector: 'page-reservationdetails',
  templateUrl: 'reservationdetails.html',
})
export class ReservationdetailsPage {
item:any;
  constructor(public DBservice: DbservicesProvider,public navCtrl: NavController, public navParams: NavParams) {
    this.item = navParams.get('item');
    console.log(this.item)
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad ReservationdetailsPage');
  }
  updatebooking(booking){
    var data={
      booking_status:"Approved",
      name:booking.name
    }
    console.log(data)
    this.DBservice.update_booking(data)
      .then(data => {
        this.DBservice.alert('Booking Approved')
        this.navCtrl.pop();
    }, error => {
      console.log(JSON.stringify(error.json()));
    });
  }
}



// WEBPACK FOOTER //
// ./src/pages/reservationdetails/reservationdetails.ts